import { EditOutlined,PlusOutlined } from '@ant-design/icons';
import { ProTable } from '@ant-design/pro-components';
import { message, Button, Badge, Image, Switch } from 'antd';
import React, { useState,useRef }  from 'react';
import EditModel from './components/edit';
import EditMicrosoftModel from './components/editMicrosoft';
import {api_tenant_list, api_tenant_edit_status} from '../../api';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';

export const waitTimePromise = async (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const waitTime = async (time) => {
  await waitTimePromise(time);
};

export default () => {
  const actionRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [showEditMicrosoftModel, setShowEditMicrosoftModel] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const closeModal = () =>{
    setShowModal(false);
    setShowEditMicrosoftModel(false);
  }

  const showEditMicrosoft = async (record) =>{
    setRowInfo(record);
    await waitTime(100);
    setShowEditMicrosoftModel(true);
  }

  const onChangeStatus = (tenant_id,checked) =>{
    console.log(tenant_id, checked)
    try {
      api_tenant_edit_status({tenant_id:tenant_id, status:checked?"1":"0"}).then((res) => {
        console.log('api_tenant_edit_status-res-----------------', res);
        if (res.data.code == 9) {
          message.success("操作成功");
          actionRef.current?.reload();
        }
        else
          message.error(res.data.msg);
      });
    } catch (error) {
      
      // return false;
    }
  }

  const columns = [
    {
      title: '租户ID',
      dataIndex: 'tenant_id',
      key: 'tenant_id',
      width: 80,
      search: false,
    },
    {
      title: '租户名称',
      dataIndex: 'tenant_name',
      key: 'tenant_name',
      ellipsis:true,
      // width: 100,
    },
    {
      title: '英文名称',
      dataIndex: 'english_name',
      key: 'english_name',
      ellipsis:true,
      // width: 150,
      search: false,
    },
    {
      title: '开通微软授权',
      dataIndex: 'is_outlook_enabled',
      key: 'is_outlook_enabled',
      width: 150,
      search: false,
      // valueType: 'select',
      // valueEnum: {
      //   "0": {
      //     text: '未开通',
      //     status: 'Default',
      //   },
      //   "1": {
      //     text: '已开通',
      //     status: 'Success',
      //     // disabled: true,
      //   },
      // },
      render: (_,record) => {
        console.log('-------is_outlook_enabled------------', _, record)
        if (record.is_outlook_enabled == '1') {
          return <div>
            <Badge status="success" text={'已开通'} /> 
            <Button size='small' type="primary" style={{marginLeft:5}} 
              onClick={() => showEditMicrosoft(record)}>修改</Button></div>;
        } else {
          return <div>
            <Badge status="default" text={'未开通'} /> 
            <Button size='small' type="primary" style={{marginLeft:5}} 
              onClick={() => showEditMicrosoft(record)}>开通</Button></div>;
            }
      }, 
    },
    {
      title: '短信通道号',
      dataIndex: 'sms_channel_number',
      key: 'sms_channel_number',
      ellipsis:true,
      width: 100,
      search: false,
    },
    {
      title: '营业执照',
      dataIndex: 'licence',
      key: 'licence',
      width: 80,
      search: false,
      render: (_,record) => {
        if (!record.licence) {
          return <span> </span>;
        } else {
          return <Image src={record.licence} width={35} height={35} />;
        }
      }, //这里放后台返回的图片的路径或者整个<img/>
    },
    {
      title: '组织机构代码',
      dataIndex: 'orgcode',
      key: 'orgcode',
      width: 100,
      search: false,
      render: (_,record) => {
        if (!record.orgcode) {
          return <span> </span>;
        } else {
          return <Image src={record.orgcode} width={35} height={35} />;
        }
      }, //这里放后台返回的图片的路径或者整个<img/>
    },
    {
      title:'添加时间',
      dataIndex: 'creat_time',
      key: 'creat_time',
      // valueType: "dateRange",
      width: 150,
      search: false,
    },
    {
      title: '状态',
      dataIndex: 'status',
      search:false,
      key:"status",
      width: 100,
      render: (_,record) => {
        return <Switch checkedChildren="激活" unCheckedChildren="停用" 
                  checked={record.status=='1'?true:false} 
                  onChange={(checked)=>{onChangeStatus(record.tenant_id, checked)}} />
      }
    },
    {
      title: '操作',
      valueType: 'option',
      width: 80,
      key: 'option',
      render: (text, record, _, action) => [
        <a  key={"edita"+record.tenant_id}
          onClick={async() => {
            console.log('record ------------- ', record)
            console.log('action ------------- ', action)
            // action?.startEditable?.(record.id);
            setRowInfo(record);
            await waitTime(100);
            setShowModal(true);
          }}
        >
          <EditOutlined key={"edit"+record.tenant_id}
            style={{backgroundColor:"rgb(24,188,156)",padding:"2px 3px",borderRadius:3,color:"white"}} />
        </a>,
        // <Popconfirm  key={"delpop"+record.tenant_id} title="确定删除吗?" onConfirm={() => {delComp(record.cid)}}>
        //   <DeleteOutlined key={"del"+record.tenant_id}
        //     style={{backgroundColor:"#ff4d4f",padding:"2px 3px",borderRadius:3,color:"white"}} />
        // </Popconfirm>
      // <a href={record.url} target="_blank" rel="noopener noreferrer" key="view">
        //   查看
        // </a>,
        // <TableDropdown
        //   key="actionGroup"
        //   onSelect={() => action?.reload()}
        //   menus={[
        //     { key: 'copy', name: '复制' },
        //     { key: 'delete', name: '删除' },
        //   ]}
        // />,
      ],
    },
  ];

   
  return (
    <div>
          
    <ProTable
      headerTitle="租户列表"
      columns={columns}
      actionRef={actionRef}
      rowKey="tenant_id"
      cardBordered
      defaultSize="small"
      request={async (params, sort, filter) => {
        console.log(params,sort, filter);
        // await waitTime(2000);
        var tableData = [];
        var res = await api_tenant_list(params);
        console.log('api_tenant_list-res-----------------', res);
        if(res.data.code == 9){
          tableData = res.data.list;
          // for (const key in tableData) {
          //   tableData[key]["key"] = key;
          // }
        }
        else
          message.error(res.data.msg);

        return {
          data: tableData,
          // current: res.data.pageNo,
          // pageSize: res.data.pageSize,
          success: true,
          // total: res.data.totalRows,
        };
      }}
      search={{
        labelWidth: 'auto',
      }}
      options={{
        reload: false, // 去掉刷新按钮
        density: false, // 去掉密度按钮
        setting: true, // 保留列设置按钮
        setting: {
          listsHeight: 400,
        },
      }}
      style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'scroll',overflowY: 'scroll'}}  
      scroll={{x:1000}}
      columnsState={{
        persistenceKey: 'pro-table-tenant',
        persistenceType: 'localStorage',
        onChange(value) {
          console.log('value: ', value);
        },
      }}

      // form={{
      //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
      //   syncToUrl: (values, type) => {
      //     if (type === 'get') {
      //       return {
      //         ...values,
      //         created_at: [values.startTime, values.endTime],
      //       };
      //     }
      //     return values;
      //   },
      // }}
      pagination={{
        pageSize: pageSize,
        showSizeChanger: true,
        onChange: (page,pagesize) => {
          console.log(page);
          console.log(pagesize);
          setPageSize(pagesize);
        },
      }}
      // dateFormatter="string"

      toolBarRender={() => [
        <Button
          // key="button"
          icon={<PlusOutlined />}
          // style={{backgroundColor:"rgb(5,168,137)"}}
          onClick={async() => {
            setRowInfo({});
            await waitTime(100);
            setShowModal(true);
          }}
          type="primary"
        >
          新增租户
        </Button>,

      ]}
    />

    <EditModel
      showModal={showModal}
      closeModal={closeModal}
      rowInfo={rowInfo}
      refreshlist={()=>{actionRef.current?.reload();}}
      showEditMicrosoft={showEditMicrosoft}
    />

    <EditMicrosoftModel
      showModal={showEditMicrosoftModel}
      closeModal={closeModal}
      rowInfo={rowInfo}
      refreshlist={()=>{actionRef.current?.reload();}}
    />

    </div>
  );
};